import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";

import { useHistory, useLocation } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import Swal from "sweetalert2";

import {
  Button,
  Flex,
  Input,
  Grid,
  GridItem,
  SimpleGrid,
  Divider,
  VStack,
  HStack,
  extendTheme,
  ChakraProvider,
  Checkbox,
  FormControl,
  Box,
  Text,
} from "@chakra-ui/react";

import CustomSelect from "../CustomSelect";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import CriancaService from "../../../main/services/CriancaService";
import DadosGeograficosService from "../../../main/services/DadosGeograficosService";
import ServicoAcolhimentoService from "../../../main/services/ServicoAcolhimentoService";
import {
  Permission,
  criancaFunc,
  visitasFunc,
} from "../../../helpers/Funcionalidades";
import { CustomDatepicker } from "../CustomDatepicker";
import VisitasService from "../../../main/services/VisitasService";
import { format, isValid, parse } from "date-fns";
import { forNames } from "../../utils/masks";
import { debounce } from "lodash";

export const FiltersCriancas = ({
  entidade,
  data,
  setData,
  setLoading,
  roleKeycloack,
  user,
  exclusao,
  setExclusao,
  atualizarDadosTabela,
  setNomeCadastro,
  loading,
  setName,
}) => {
  const formRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const initialLoad = useRef(true);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const [showCadastrar, setShowCadastrar] = useState(false);

  const [initialValues, setInitialValues] = useState({
    nome: "",
    nomeExato: [],
    nmFiliacao: "",
    munSeacId: "",
    vinculo: "",
    dataInicial: "",
    dataFinal: "",
    idSeac: "",
    tipoMotivo: "",
    pageSize: 10,
    page: 0,
  });

  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });
  const [nomesServicosAcolhimento, setNomesServicosAcolhimento] = useState({
    options: [],
    isLoading: false,
  });
  const [opcoesFiliacao, setOpcoesFiliacao] = useState({
    options: [],
    isLoading: false,
  });

  //const [firstLocationUpdate, setFirstLocationUpdate] = useState(true);

  const theme = extendTheme({
    components: {
      Checkbox: {
        baseStyle: {
          control: {
            bg: "#FFF",
            _checked: {
              bg: "rgb(49, 130, 206)",
            },
          },
        },
      },
    },
  });

  const cadastrarAlert = (props) => {
    Swal.fire({
      title: `Sua consulta encontrou ${
        data ? data.totalElements : ""
      } registros`,
      text: "Tem certeza que deseja cadastrar um novo?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        if (data && props.values.nome) {
          history.push("/" + entidade + "/cadastrar?nome=" + props.values.nome);
        } else {
          history.push("/" + entidade + "/cadastrar");
        }
      }
    });
  };

  useEffect(() => {
    if (sessionStorage.getItem(entidade + "-filter")) {
      const tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      setInitialValues(tempObj);
      setName && setName(tempObj.nome);
    }
  }, [entidade, setName]);

  useEffect(() => {
    const autoValues = ["pageSize", "totalItems", "totalPages", "page"];
    let tempTestEmpty = true;
    for (let key in initialValues) {
      if (key === "nomeExato") {
        if (initialValues[key].length !== 0) tempTestEmpty = false;
      } else {
        if (!autoValues.includes(key) && initialValues[key])
          tempTestEmpty = false;
      }
    }

    const passou = sessionStorage.getItem("crianca-passou");
    if (!tempTestEmpty && passou !== "true") {
      if (formRef.current) {
        formRef.current.handleSubmit();
      }
    }
  }, [initialValues]);

  useEffect(() => {
    if (!initialLoad.current) {
      if (formRef.current) {
        formRef.current.handleSubmit();
      }
    } else {
      initialLoad.current = false;
    }
  }, [location]);

  const handleGetMunicipios = () => {
    setMunicipios({ ...municipios, isLoading: true });
    DadosGeograficosService.pesquisarMunicipios(33).then((res) => {
      setMunicipios({ options: res.data, isLoading: false });
    });
  };

  const handleGetNomesServicosAcolhimento = (props) => {
    setNomesServicosAcolhimento({
      ...nomesServicosAcolhimento,
      isLoading: true,
    });

    ServicoAcolhimentoService.pesquisarServicosAcolhimento({
      municipioId: props.values?.munSeacId?.id
        ? props.values?.munSeacId?.id
        : "",
    }).then((res) => {
      setNomesServicosAcolhimento({ options: res.data, isLoading: false });
    });
  };

  const handleGetServicosAcolhimento = useCallback(() => {
    setNomesServicosAcolhimento((prev) => ({
      ...prev,
      isLoading: true,
    }));

    const fetchService =
      entidade === "crianca"
        ? ServicoAcolhimentoService.listarServicosAcolhimentoAtivos
        : ServicoAcolhimentoService.getServicosAcolhimentoAtivosSuspensosLogado;

    fetchService().then((res) => {
      const formattedOptions = res.data.map((item) => ({
        label: item.pessoaJuridica?.nomeFantasia,
        value: item.id,
      }));

      if (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento)) {
        const filteredOptions = res.data
          .filter((item) =>
            user?.orgaoExterno?.includes(item.pessoaJuridica.id)
          )
          .map((item) => ({
            label: item.pessoaJuridica?.nomeFantasia,
            value: item.id,
          }));

        setInitialValues((prevState) => ({
          ...prevState,
          idSeac: filteredOptions[0],
        }));
      }

      setNomesServicosAcolhimento({
        options: formattedOptions,
        isLoading: false,
      });
    });
  }, [entidade, roleKeycloack, user?.orgaoExterno]);

  useEffect(() => {
    if (
      entidade === "visitas" &&
      roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento)
    ) {
      handleGetServicosAcolhimento();
    }
  }, [handleGetServicosAcolhimento, roleKeycloack, entidade]);

  const handleGetVinculo = () => {
    setOpcoesFiliacao({ ...opcoesFiliacao, isLoading: true });
    CriancaService.getTipoReferenciaPaeMae().then((res) => {
      const formattedOptions = res.data.map((item) => ({
        label: item.descricao,
        value: item.id,
      }));
      setOpcoesFiliacao({
        options: formattedOptions,
        isLoading: false,
      });
    });
  };

  const isValidDate = (value) => {
    if (!!value) {
      if (value.length === 10) {
        return isValid(parse(value, "dd/MM/yyyy", new Date()));
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const funcPesquisarCrianca = useCallback(
    (valuesToSend) => {
      CriancaService.pesquisarCriancas(valuesToSend).then((res) => {
        sessionStorage.setItem(entidade + "-filterSearch", true);
        const tempObj = JSON.parse(
          sessionStorage.getItem(entidade + "-filter")
        );

        sessionStorage.setItem(
          entidade + "-filter",
          JSON.stringify({
            ...tempObj,
            totalItems: res.data.totalElements,
            totalPages: res.data.totalPages,
          })
        );

        setData(res.data);
        setLoading(false);
      });
    },
    [entidade, setData, setLoading]
  );

  const funcPesquisar = useCallback(
    (nome, vinculo, idSeac, dataInicial, dataFinal) => {
      let parsedDataInicial;
      let parsedDataFinal;
      let formattedDataInicial;
      let formattedDataFinal;

      if (dataInicial && isValidDate(dataInicial)) {
        parsedDataInicial = parse(dataInicial, "dd/MM/yyyy", new Date());
        formattedDataInicial = format(parsedDataInicial, "yyyy-MM-dd");
      }

      if (dataFinal && isValidDate(dataFinal)) {
        parsedDataFinal = parse(dataFinal, "dd/MM/yyyy", new Date());
        formattedDataFinal = format(parsedDataFinal, "yyyy-MM-dd");
      }

      VisitasService.pesquisarVisitas(
        nome ? nome : "",
        vinculo ? vinculo.value : "",
        roleKeycloack.includes(visitasFunc.visitaTipoConsultar) ? true : false,
        idSeac ? idSeac.value : "",
        formattedDataInicial ? formattedDataInicial : "",
        formattedDataFinal ? formattedDataFinal : ""
      ).then((res) => {
        const filteredContent = res.data.content.filter((item) => !!item);

        const updatedData = {
          ...res.data,
          content: filteredContent,
        };

        setData(updatedData);
        setLoading(false);
        setExclusao(false);
      });
    },
    [roleKeycloack, setData, setExclusao, setLoading]
  );

  useEffect(() => {
    if (exclusao && entidade === "visitas") {
      setLoading(true);

      const tempObj = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
      setInitialValues(tempObj);

      funcPesquisar(
        tempObj.nome,
        tempObj.vinculo,
        tempObj.idSeac,
        tempObj.dataInicial,
        tempObj.dataFinal
      );
    }
  }, [exclusao, entidade, funcPesquisar, setLoading]);

  useEffect(() => {
    const tempObj = JSON.parse(sessionStorage.getItem("table-" + entidade));
    const storage = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
    const pesquisou = sessionStorage.getItem(entidade + "-filterSearch");
    const passou = sessionStorage.getItem("crianca-passou");

    if (atualizarDadosTabela || (pesquisou && passou)) {
      setLoading(true);

      if (pesquisou && passou) {
        setShowCadastrar(true);
      }

      const valuesToSend = {
        nome: storage?.nome ? storage.nome : "",
        nomeExato: storage?.nomeExato?.includes("Possui") ? true : false,
        nmFiliacao: storage?.nmFiliacao ? storage.nmFiliacao : "",
        tipoMotivo: storage?.tipoMotivo ? storage.tipoMotivo.value : "",
        munSeacId: storage?.munSeacId ? storage.munSeacId.id : "",
        idSeac: storage?.idSeac ? storage.idSeac.id : "",
        pageSize: storage?.pageSize ? storage.pageSize : "",
        page: storage?.page ? storage.page : "",
        sortField: tempObj ? tempObj[0]?.id : "nome",
        sortType: tempObj ? (tempObj[0]?.desc ? "DESC" : "ASC") : "ASC",
      };

      funcPesquisarCrianca(valuesToSend);
    }
  }, [
    exclusao,
    atualizarDadosTabela,
    location.state,
    entidade,
    funcPesquisarCrianca,
    setLoading,
  ]);

  const handleSubmit = (values, actions) => {
    const storage = JSON.parse(sessionStorage.getItem(entidade + "-filter"));
    setTimeout(() => {
      const {
        nome,
        nmFiliacao,
        nomeExato,
        tipoMotivo,
        munSeacId,
        idSeac,
        vinculo,
        dataInicial,
        dataFinal,
      } = values;
      values.page = 0;
      values.pageSize = storage?.pageSize ? storage.pageSize : 10;
      const valuesToSend = {
        nome: nome ? nome : "",
        nomeExato: nomeExato?.includes("Possui") ? true : false,
        nmFiliacao: nmFiliacao ? nmFiliacao : "",
        tipoMotivo: tipoMotivo ? tipoMotivo.value : "",
        munSeacId: munSeacId ? munSeacId.id : "",
        idSeac: idSeac ? idSeac.id : "",
        pageSize: storage?.pageSize ? storage.pageSize : 10,
        page: 0,
      };

      if (entidade === "crianca") {
        values.desc = false;
        values.sort = "nome";
        valuesToSend.sortField = "nome";
        valuesToSend.sortType = "ASC";
        sessionStorage.setItem(
          "table-crianca",
          JSON.stringify([{ id: "nome", desc: false }])
        );
      }
      setLoading(true);

      sessionStorage.setItem(entidade + "-filter", JSON.stringify(values));
      if (entidade === "crianca") {
        funcPesquisarCrianca(valuesToSend);
      } else if (entidade === "visitas") {
        funcPesquisar(nome, vinculo, idSeac, dataInicial, dataFinal);
      }
      actions.setSubmitting(false);

      setShowCadastrar(true);
    }, 200);
  };

  const debouncedSetName = useMemo(
    () => debounce((value) => setName(value), 400),
    [setName]
  );

  const handleChange = useCallback(
    (value) => {
      debouncedSetName(value);
    },
    [debouncedSetName]
  );

  return (
    <Flex flexDir="column" alignItems="center" w="100%">
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}
        innerRef={formRef}
      >
        {(props) => (
          <Form style={{ width: "100%" }}>
            <Flex flexDirection="column" alignItems="center">
              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  sm: "repeat(2, 1fr)",
                  lg: "repeat(6, 1fr)",
                }}
                rowGap="10px"
                columnGap="18px"
                w="100%"
                mt="2px"
              >
                {entidade === "crianca" ? (
                  <>
                    <GridItem colSpan={{ base: 2, sm: 2, lg: 3 }}>
                      <VStack alignItems="flex-start">
                        <Field name="nome">
                          {({ field, form }) => (
                            <Input
                              {...field}
                              h="42px"
                              name="nome"
                              autoFocus
                              id="search-nome"
                              backgroundColor="white"
                              autoComplete="off"
                              onChange={(e) => {
                                const formattedValue = forNames(e.target.value);
                                props?.setFieldValue("nome", formattedValue);
                                setName && handleChange(formattedValue);
                              }}
                              placeholder="Pesquise pelo Nome/Nome Social"
                            />
                          )}
                        </Field>
                        <HStack spacing="20px">
                          <Field name="nomeExato">
                            {({ field, form }) => (
                              <FormControl id="nomeExato" width="max-content">
                                <ChakraProvider theme={theme}>
                                  <Checkbox
                                    {...field}
                                    value="Possui"
                                    name="nomeExato"
                                    id="nomeExato"
                                    whiteSpace="nowrap"
                                    isChecked={field?.value?.includes("Possui")}
                                    onChange={(e) => {
                                      props.setFieldValue(
                                        "nomeExato",
                                        field.value.includes("Possui")
                                          ? []
                                          : ["Possui"]
                                      );
                                    }}
                                  >
                                    Nome exato
                                  </Checkbox>
                                </ChakraProvider>
                              </FormControl>
                            )}
                          </Field>
                        </HStack>
                      </VStack>
                    </GridItem>

                    <GridItem colSpan={{ base: 2, sm: 2, lg: 3 }}>
                      <Field name="nmFiliacao">
                        {({ field, form }) => (
                          <Input
                            {...field}
                            h="42px"
                            name="nmFiliacao"
                            id="search-nmFiliacao"
                            backgroundColor="white"
                            autoComplete="off"
                            placeholder="Pesquise pela Filiação"
                          />
                        )}
                      </Field>
                    </GridItem>

                    <GridItem colSpan={2}>
                      <CustomSelect
                        isClearable={true}
                        value={props.values.munSeacId || ""}
                        searchable={true}
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={municipios.isLoading}
                        options={municipios.options}
                        placeholder="Município do Serviço de Acolhimento"
                        onChange={(value) => {
                          props.setFieldValue("munSeacId", value);
                          props.setFieldValue("idSeac", "");
                        }}
                        onFocus={
                          municipios.options.length === 0
                            ? handleGetMunicipios
                            : null
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={2}>
                      <CustomSelect
                        isClearable={true}
                        value={props.values.idSeac || ""}
                        searchable={true}
                        getOptionLabel={(option) => option?.nomeFantasia}
                        getOptionValue={(option) => option.id}
                        isLoading={nomesServicosAcolhimento.isLoading}
                        options={nomesServicosAcolhimento.options}
                        placeholder="Nome do Serviço de Acolhimento"
                        onChange={(value) =>
                          props.setFieldValue("idSeac", value)
                        }
                        onFocus={() => handleGetNomesServicosAcolhimento(props)}
                      />
                    </GridItem>

                    <GridItem colSpan={2}>
                      <CustomSelect
                        value={
                          props.values.tipoMotivo
                            ? props.values.tipoMotivo
                            : null
                        }
                        options={[
                          { label: "Acolhido", value: "Acolhido" },
                          { label: "Desligado", value: "Desligado" },
                          { label: "Pendente", value: "Pendente" },
                        ]}
                        placeholder="Selecione a Situação"
                        onChange={(value) => {
                          props.setFieldValue("tipoMotivo", value ? value : "");
                        }}
                      />
                    </GridItem>
                  </>
                ) : (
                  <>
                    <GridItem colSpan={3}>
                      <Field name="nome">
                        {({ field, form }) => (
                          <Input
                            {...field}
                            h="42px"
                            name="nome"
                            autoFocus
                            id="search-nome"
                            backgroundColor="white"
                            autoComplete="off"
                            placeholder="Pesquise pelo Nome da Criança/Adolescente"
                          />
                        )}
                      </Field>
                    </GridItem>
                    <GridItem colSpan={3}>
                      <CustomSelect
                        value={props.values.vinculo}
                        searchable={true}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        isLoading={
                          opcoesFiliacao ? opcoesFiliacao.isLoading : false
                        }
                        options={opcoesFiliacao ? opcoesFiliacao.options : null}
                        placeholder="Selecione o Vínculo"
                        onChange={(value) => {
                          props.setFieldValue("vinculo", value);
                        }}
                        onFocus={
                          opcoesFiliacao?.options?.length === 0
                            ? handleGetVinculo
                            : null
                        }
                      />
                    </GridItem>
                    <GridItem colSpan={3}>
                      <CustomSelect
                        isClearable={true}
                        value={props.values.idSeac || ""}
                        searchable={true}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        isLoading={
                          nomesServicosAcolhimento
                            ? nomesServicosAcolhimento.isLoading
                            : false
                        }
                        options={
                          nomesServicosAcolhimento
                            ? nomesServicosAcolhimento.options
                            : null
                        }
                        placeholder="Selecione o Serviço de Acolhimento"
                        onChange={(value) => {
                          props.setFieldValue("idSeac", value);
                        }}
                        onFocus={
                          nomesServicosAcolhimento?.options?.length === 0
                            ? handleGetServicosAcolhimento
                            : null
                        }
                        isDisabled={roleKeycloack.includes(
                          criancaFunc.visualizarTudoAcolhimento
                        )}
                      />
                    </GridItem>
                    <GridItem
                      colSpan={2}
                      display={"flex"}
                      gap={6}
                      alignItems={"center"}
                    >
                      <Box>
                        <CustomDatepicker
                          isClearable={false}
                          value={props.values.dataInicial}
                          setValue={(date) =>
                            props.setFieldValue("dataInicial", date)
                          }
                          placeholder={"DD/MM/AAAA"}
                        />
                      </Box>
                      <Text>até</Text>
                      <Box>
                        <CustomDatepicker
                          value={props.values.dataFinal}
                          setValue={(date) =>
                            props.setFieldValue("dataFinal", date)
                          }
                          placeholder={"DD/MM/AAAA"}
                        />
                      </Box>
                    </GridItem>
                  </>
                )}
              </Grid>

              <SimpleGrid
                mt="20px"
                columns={{ base: 3, lg: 3 }}
                spacing="15px"
                w={{ base: "100%", lg: "47%" }}
              >
                <Permission
                  roleKeycloack={roleKeycloack}
                  func={criancaFunc.pesquisar}
                >
                  <Button
                    type="submit"
                    translate="no"
                    color="#FFF"
                    backgroundColor="#169499"
                    fontWeight={700}
                    fontSize="15px"
                    lineHeight="21.6px"
                    _hover={{ bg: "#169499" }}
                    isLoading={props.isSubmitting}
                  >
                    Pesquisar
                  </Button>
                </Permission>
                <Button
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={700}
                  fontSize="15px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  onClick={() => {
                    sessionStorage.removeItem(entidade + "-filter");
                    props.resetForm({
                      values: {
                        nome: "",
                        nomeExato: [],
                        nmFiliacao: "",
                        munSeacId: "",
                        idSeac: "",
                        vinculo: "",
                        dataInicial: "",
                        dataFinal: "",
                        tipoMotivo: "",
                      },
                    });
                  }}
                >
                  Limpar
                </Button>
                {showCadastrar && (
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={
                      entidade === "visitas"
                        ? visitasFunc.visitaCadastrar
                        : entidade === "crianca"
                        ? criancaFunc.cadastrar
                        : ""
                    }
                  >
                    <Button
                      color="#FFF"
                      backgroundColor={loading ? "gray.500" : "#169499"}
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      isDisabled={loading}
                      _hover={{ bg: !loading && "#169499" }}
                      onClick={
                        data
                          ? data?.content?.length > 0 && entidade === "crianca"
                            ? () => cadastrarAlert(props)
                            : () => {
                                history.push(
                                  "/" +
                                    entidade +
                                    "/cadastrar?nome=" +
                                    props.values.nome
                                );
                              }
                          : () => {
                              history.push("/" + entidade + "/cadastrar");
                            }
                      }
                    >
                      Cadastrar
                    </Button>
                  </Permission>
                )}
              </SimpleGrid>
            </Flex>
          </Form>
        )}
      </Formik>

      <Divider
        borderColor="#DDEBEA"
        orientation="horizontal"
        mt="18px"
        h="2px"
      />
    </Flex>
  );
};
